import { render } from "./price-alerts.vue?vue&type=template&id=59f5b6e5"
const script = {}

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__